<div class="modal-header">
  <button type="button" class="close" ng-click="$close()">&times;</button>
  <h3 class="modal-title">Filtros avançados</h3>
</div>
<div class="modal-body">
  <div class="form-horizontal">
    <div class="form-group">
      <label class="control-label col-xs-3">Operações</label>
      <div class="col-xs-9">
        <ui-select multiple ng-model="filters.tipos" append-to-body="true">
          <ui-select-match>{{$item.descricao}}</ui-select-match>
          <ui-select-choices repeat="tipo in data.operacoes | filter: {descricao: $select.search}">
            <span ng-bind-html="tipo.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-xs-3">Culturas</label>
      <div class="col-xs-9">
        <ui-select multiple ng-model="filters.culturas" append-to-body="true">
          <ui-select-match>{{$item.descricao | capitalize}}</ui-select-match>
          <ui-select-choices repeat="tipo in data.culturas | filter: {descricao: $select.search}">
            <span ng-bind-html="tipo.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-xs-3">Usuários</label>
      <div class="col-xs-9">
        <ui-select multiple ng-model="filters.usuarios" append-to-body="true">
          <ui-select-match>{{$item.nome_completo | capitalize}}</ui-select-match>
          <ui-select-choices repeat="tipo in data.usuariosWithHistory | filter: {nome_completo: $select.search}">
            <span ng-bind-html="tipo.nome_completo | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-white" ng-click="$close()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="$close(filters)">OK</button>
</div>
